// 监听sessionStorage缓存改变
export const monitorStorage = () => {
    // 1.  触发标志位改变事件
    window.localStorage.setItem('constant', Date.now().toString());
    window.addEventListener('storage', (event) => {
        if (!event.newValue) {
            return;
        }
        // 2. 监听标志位改变事件
        if (event.key === 'constant') {
            // 3. 触发传递信息的改变事件
            const uInfo = sessionStorage.getItem('USER_INFO');
            const user = JSON.parse(uInfo);
            const userInfo = {
                userInfo: user,
                token: sessionStorage.getItem('ACCESS_TOKEN'),
            };
            localStorage.setItem('storeSessionData', JSON.stringify(userInfo));
            localStorage.removeItem('storeSessionData');
        }
        else if (event.key === 'storeSessionData') {
            // 4. 监听 传递信息 的改变事件
            const user = JSON.parse(event.newValue);
            if (user.userInfo && user.userInfo != null) {
                const uInfo = sessionStorage.getItem('USER_INFO');
                const use = JSON.parse(uInfo) || {};
                if (user.userInfo.id === use.id) {
                    sessionStorage.setItem('USER_INFO', JSON.stringify(user.userInfo));
                    if (user.token && user.token != null) {
                        sessionStorage.setItem('ACCESS_TOKEN', user.token);
                    }
                    //
                }
            }
            localStorage.removeItem('storeSessionData');
        }
    });
};
// 下载文件模板用到的code集合,与菜单路由绑定在一起
export const getMenuBusinessCodes = (list, codes) => {
    if (list) {
        list.forEach((item) => {
            // 记录menuCode,key是为系统左侧菜单路由
            if (item.code && item.key) {
                codes[`${item.key}/`] = item.code;
            }
            if (item?.children?.length > 0) {
                getMenuBusinessCodes(item.children, codes);
            }
        });
    }
};
export function loadCss(hrefUrl) {
    return new Promise((resolve, reject) => {
        // 判断当前css是否已经加载过
        const linkNodes = [].slice
            .call(document.querySelectorAll('link'))
            .map((item) => item?.href);
        if (linkNodes.includes(hrefUrl)) {
            return resolve(true);
        }
        const link = document.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.href = hrefUrl;
        document.head.appendChild(link);
        link.onload = () => {
            resolve(true);
        };
        link.onerror = (err) => {
            reject(err);
        };
    });
}
export * from './env';
export * from './systemIds';
export * from './utils';
export * from './pathTools';
export * from './flattens';
export * from './constant';
export * from './ase';
export * from './form';
export * from './global';
